export default "__VITE_ASSET__BqBVeK7s__"